import React from "react";
import { Outlet } from "react-router-dom";

export default function DefaultLayout() {
  return (
    <div className="overflow-x-scroll sm:overflow-hidden">
      <Outlet />
    </div>
  );
}
